import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import emiImg from "../assets/emi.png";

export default function Homeabout() {
  return (
    <div className="row d-flex justify-content-center py-4">
      <div className="col-10">
        <div className=" py-5">
          <h2 className=" mb-4">About Shubh Paisa Gold Loan</h2>
          <div className="row ">
            <div className="col-md-6">
              <p>
                Unlock the true value of your gold with Shubh Paisa, offering
                gold loans at the most competitive interest rates in the market.
                A gold loan from us ensures not just financial support but also
                an experience marked by ease and satisfaction. As the leading
                gold loan provider in the country, we take pride in our
                extensive portfolio, catering to diverse needs.
                <br />
                <br />
                When you’re in search of low interest gold loan, think of Shubh
                Paisa. We stand out for our low-interest rates, making your gold
                loan journey affordable and efficient. Our commitment to
                customer satisfaction reflects in quick disbursals and
                attractive interest rates.
              </p>
            </div>

            <div className="col-md-6  ">
              <p>
                With Shubh Paisa, your gold is not just an ornament; it’s a
                valuable asset that opens doors to financial opportunities.
                Explore our instant Gold Loan@Home service, where you can secure
                a gold jewel loan with low interest rate from the comfort of
                your home in three simple steps: Request a gold loan, have your
                gold valued at home, and receive money instantly in your bank
                account. Take advantage of Shubh Paisa’s low-interest rates to
                meet your financial goals effortlessly.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
